import angular from 'angular';
import insuranceNotesTemplates from './insuranceNotesTemplates';
import './style.scss';

export default angular
  .module('components.insuranceNotesTemplates', [])
  .component('insuranceNotesTemplates', insuranceNotesTemplates).name;
